var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cs-dashboard"}},[_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('dashboard_title')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }